import { render, staticRenderFns } from "./searchTerms.vue?vue&type=template&id=c4bb154a&scoped=true"
import script from "./searchTerms.vue?vue&type=script&lang=js"
export * from "./searchTerms.vue?vue&type=script&lang=js"
import style0 from "./searchTerms.vue?vue&type=style&index=0&id=c4bb154a&prod&lang=less&scoped=true"
import style1 from "./searchTerms.vue?vue&type=style&index=1&id=c4bb154a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_gliqtm7r2yknapxh4mg6r2qyi4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bb154a",
  null
  
)

export default component.exports